import { render, staticRenderFns } from "./adFooter.vue?vue&type=template&id=6556d364"
import script from "./adFooter.vue?vue&type=script&lang=js"
export * from "./adFooter.vue?vue&type=script&lang=js"
import style0 from "./adFooter.vue?vue&type=style&index=0&id=6556d364&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports